module.exports = __webpack_public_path__ + "media/images/honey-logo-0d2d3600a2a6587191dcac928ed13941.png";